import React, { ReactElement } from "react";
import Alert from "react-bootstrap/Alert";

interface Props {
    variant: string,
    message: string,
}
/**
 * props: variant- bootstrap variant to style Alert
 *        message
 * state: none
 */
export default function AlertMessage({ variant, message }: Props): ReactElement {
    return <Alert variant={variant}>{message}</Alert>;
}
